import { Check } from "lucide-react";

const OPTIONS = [
  { id: "warm", label: "Warm minimalist", hint: "Porcelain · oak · blush" },
  { id: "loft", label: "SoHo loft-modern", hint: "Concrete · steel · greenery" },
];

export default function StylePicker({ value, onChange, busy }) {
  return (
    <div className="card" data-testid="style-picker" style={{ display: "flex", alignItems: "center", gap: 18, padding: "18px 22px", marginTop: 28 }}>
      <div style={{ marginRight: "auto" }}>
        <div className="eyebrow">Selected spa style</div>
        <div style={{ fontSize: 13, color: "var(--ink-60)", marginTop: 4 }}>Drives the S3 hero, Clip 3, the rough cut and the prompt export.</div>
      </div>
      {OPTIONS.map((o) => {
        const active = value === o.id;
        return (
          <button key={o.id} data-testid={`style-${o.id}`} disabled={busy} onClick={() => onChange(o.id)}
            style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 18px", borderRadius: 999, cursor: "pointer", border: `1px solid ${active ? "var(--burgundy)" : "var(--ink-12)"}`, background: active ? "var(--burgundy)" : "#fff", color: active ? "var(--porcelain)" : "var(--charcoal)", transition: "background-color 180ms ease, color 180ms ease, border-color 180ms ease", textAlign: "left", opacity: busy ? .6 : 1 }}>
            <span style={{ width: 20, height: 20, borderRadius: "50%", border: `1.5px solid ${active ? "var(--porcelain)" : "var(--ink-40)"}`, display: "flex", alignItems: "center", justifyContent: "center" }}>{active && <Check size={12} />}</span>
            <span><div style={{ fontSize: 13, fontWeight: 700 }}>{o.label}</div><div style={{ fontSize: 11, opacity: .75 }}>{o.hint}</div></span>
          </button>
        );
      })}
    </div>
  );
}
